// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.BusinessAssociations_header__3kSgH {\n  margin-bottom: 28px; }\n", ""]);
// Exports
exports.locals = {
	"header": "BusinessAssociations_header__3kSgH"
};
module.exports = exports;
